import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import React, { useEffect, useRef, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import { KuposSelectBox } from '../../../common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation, withTranslation } from 'react-i18next';

const ThemeElevenSearchBox = props => {
  const {t} = useTranslation('common');
  const operator = props.home.operator;
  const [roundTrip ,setRoundTrip] = useState(false);
  return (
    <div className="themes-theme-eleven-search-box">
      {/* <style>{cssStyle}</style> */}
      <div className="new-container">
        <div className="home-main-selection-container">
          <div
            className="kupos-card  kupos-card-padding-l"
            style={{
              background:
                operator && operator.color_codes && operator.color_codes.tertiary_color
                  ? operator.color_codes.tertiary_color
                  : null,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <span
              className="bold-text mb5 font10-pasaje"
              style={{
                color:
                  operator && operator.color_codes && operator.color_codes.primary_text_color
                    ? operator.color_codes.primary_text_color
                    : null,
                marginRight: 5,
                fontSize:"19px"
              }}
            >
             {t("SEARCH_BOX.COMPRA")}
            </span>
            <span
              className="mb5 font10-pasaje"
              style={{
                color:
                  operator && operator.color_codes && operator.color_codes.primary_text_color
                    ? operator.color_codes.primary_text_color
                    : null,
                marginRight: 100,
                fontSize:"19px"
              }}
            >
              {t("SEARCH_BOX.TU_PASAJE")}
            </span>
            <div className="radio-buttons-container" style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{ marginRight: 30, color:'#0152a6',fontWeight: 'bold',fontSize:"14px"}}>
                <input type="radio" name="ticketType" checked={roundTrip} onChange={()=>{setRoundTrip(true)}}
                style={{ width: '18px', height: '18px', marginRight: '8px' }}/>
                {t("SEARCH_BOX.ROUND_TRIP")}
              </label>
              <label style={{ marginLeft: 10, color:'#0152a6',fontSize:"14px"}}>
                <input type="radio" name="ticketType" checked={!roundTrip} onChange={()=>{setRoundTrip(false)}}
                style={{ width: '18px', height: '18px', marginRight: '8px', }}/>
                {t("SEARCH_BOX.ONE_WAY")}
              </label>
            </div>
          </div>
          <CuponeraInput data={props} roundTrip={roundTrip} />
        </div>
      </div>
    </div>
    </div >
  );
};

const CuponeraInput = props => {
  const { t, history, home, actions, operator, common } = props.data;
  const errorInitialState = {
    source: '',
    destination: '',
    date: '',
  };

  const destinationRef = useRef({});

  useEffect(() => {
    sessionStorage.removeItem('tariffData');
  }, []);

  const [error, setError] = useState(errorInitialState);
  const [count, setCount] = useState(1);
  const { loading, setLoading } = props.data;

  const onSourceChange = value => {
    setError({ ...error, source: null });
    actions.pbSetSourceCity(value);
    getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

    if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
      onDestinationChange(null);
    }

    destinationRef.current.onMenuOpen();
    destinationRef.current.select.focus();
  };

  const onDestinationChange = value => {
    setError({ ...error, destination: null });
    actions.pbSetDestinationCity(value);
  };

  const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function (obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function (obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };
  const onSubmit = e => {
    e.preventDefault();
    if (!home.pbSourceCity) {
      setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
      return;
    } else if (!home.pbDestinationCity) {
      setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
      return;
    } else {
      setLoading(true);
      //   sessionStorage.setItem('SourceCity', JSON.stringify(home.pbSourceCity));
      //   sessionStorage.setItem('DestinationCity', JSON.stringify(home.pbDestinationCity));

      const arr = Array.from({ length: 1 }, (_, index) => {
        return { number: index + 1 };
      });

      // console.log('arr', arr, props);
      props.data.actions.selectSeatOnward({ selectedSeatsToBook: arr });

      props.data.actions.apiCall({
        type: 'home',

        url: ApiUrls.getTariffTheme11({
          originId: home.pbSourceCity.value,
          destinationId: home.pbDestinationCity.value,
          noOfPassengers: count,
        }),
        callback: res => {
          setLoading(false)
          if (res && res.data && res.data.success) {
            sessionStorage.setItem('tariffData', JSON.stringify(res.data.data.tariff));
            if (props.roundTrip){
              history.push('/terminal/booking?round_trip=true');
            }else{
              history.push('/terminal/booking');
            }
            
            
          }
        },
        method: 'GET',
      });
    }
  };

  const handleCount = c => {
    if (c < 1) {
      return;
    }

    setCount(c);
  };

  let terminalCities = [];
  let airportCities = [];

  if (home && home.uniqueCities) {
    terminalCities = home.uniqueCities.filter(item => item.category === 'terminal');
    airportCities = home.uniqueCities.filter(item => item.category === 'airport');
  }
  
  return (
    <React.Fragment>
      <form onSubmit={onSubmit}>
        <div className="home-selection-input-boxes mt-20">
          <div className="home-selection-input-box border-none font10 ">
            <span
              className="label font11"
              style={{
                color:
                  operator && operator.color_codes && operator.color_codes.primary_text_color
                    ? operator.color_codes.primary_text_color
                    : null,

                marginTop: 10,
              }}
            >
              {t('HOME.ORIGIN')}
            </span>
            <KuposSelectBox
              reactSelect
              selectType="origin"
              options={
                home.uniqueCities || []
                // home.pbDestinationCity
                //   ? home.pbDestinationCity && home.pbDestinationCity.category === 'terminal'
                //     ? airportCities
                //     : terminalCities
                //   : home.uniqueCities || []
              }
              selectedOption={home.pbSourceCity}
              onChange={onSourceChange}
              icon={getIcons('Origin', operator)}
              hideArrow={true}
              error={error.source ? true : false}
              errorMessage={t(error.source)}
              placeholder={t('HOME.ORIGIN')}
              height={40}
              t={t}
              optionBgColor="#fec72d"
              optionTextColor="#000"
            />
          </div>

          <div className="home-selection-input-box font10 border-none">
            <span
              className="label font11"
              style={{
                color:
                  operator && operator.color_codes && operator.color_codes.primary_text_color
                    ? operator.color_codes.primary_text_color
                    : null,
                marginTop: 10,
              }}
            >
              {t('HOME.DESTINATION')}
            </span>
            <KuposSelectBox
              reactSelect
              selectType="destination"
              selectRef={destinationRef}
              options={
                home.pbSourceCity
                  ? home.pbSourceCity && home.pbSourceCity.category === 'terminal'
                    ? airportCities
                    : terminalCities
                  : []
              }
              selectedOption={home.pbDestinationCity}
              onChange={onDestinationChange}
              icon={getIcons('Destination', operator)}
              hideArrow={true}
              error={error.destination ? true : false}
              errorMessage={t(error.destination)}
              placeholder={t('HOME.DESTINATION')}
              height={40}
              t={t}
              optionBgColor="#fec72d"
              optionTextColor="#000"
            />
          </div>

          <div className=" home-selection-input-box-counter font10">
            <span
              className="label font11"
              style={{
                color:
                  operator && operator.color_codes && operator.color_codes.primary_text_color
                    ? operator.color_codes.primary_text_color
                    : null,
                marginRight: 5,
              }}
            >
              {t("SEARCH_BOX.QUANTITY")}
            </span>

            <div className="total " style={{ display: 'flex' }}>
              <div
                className="decrement"
                style={{
                  background: 'white',
                  padding: 10,
                  borderTopLeftRadius: 10,
                  borderBottomLeftRadius: 10,
                  cursor: 'pointer',
                  width: 30,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => handleCount(count - 1)}
              >
                <span>-</span>
              </div>

              <div
                className="count"
                style={{
                  background: 'white',
                  padding: '10px 15px',
                  margin: '0 4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <span style={{ marginTop: 2, fontSize:13 }}>{count}</span>
              </div>

              <div
                className="increament"
                onClick={() => handleCount(count + 1)}
                style={{
                  background: 'white',
                  padding: 10,
                  borderTopRightRadius: 10,
                  borderBottomRightRadius: 10,
                  cursor: 'pointer',
                  width: 30,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <span style={{ marginTop: 2 }}>+</span>
              </div>
            </div>
          </div>

          <div className="home-selection-input-box font12 datebox">
            <button
              style={{
                background: !loading
                  ? operator && operator.color_codes && operator.color_codes.button_color
                    ? operator.color_codes.button_color
                    : ''
                  : 'gray',
              }}
              className="kupos-button home-selection-input-button less-bold-text "
              type="submit"
            >
              {/* <img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} /> */}
              <span>
                {loading ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <React.Fragment>
                    <img src="/assets/centropuerto/Home/Buscar Icon.svg" style={{ height: 18 }} />
                    {t('HOME.SEARCH')}
                  </React.Fragment>
                )}
              </span>
            </button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...actions,
        ...serviceActions,
        ...myAccountActions,
        ...commonActions,
        ...homeActions,
      },
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(ThemeElevenSearchBox));



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/components/ThemeElevenSearchBox.js